import { SimpleEventEmitter } from "@sail/utils";
import patchBrowserStorage from "../browserStorage/patchBrowserStorage";
export default function createLocalStorageEventListener(reports) {
    const simpleEventEmitter = new SimpleEventEmitter();
    patchBrowserStorage('localStorage', simpleEventEmitter.notify.bind(simpleEventEmitter), reports);
    // Listen to storage changes in other windows (i.e. this won't fire on the same page
    // that is making the change).
    if (typeof globalThis !== 'undefined' && typeof globalThis.addEventListener === 'function') {
        addEventListener('storage', function storageChangeListener(evt) {
            const { key, newValue, storageArea } = evt;
            if (storageArea !== localStorage) {
                return;
            }
            // Clear event
            if (key == null) {
                return simpleEventEmitter.notify({
                    type: 'clear'
                });
            }
            // Remove event
            if (newValue == null) {
                return simpleEventEmitter.notify({
                    type: 'remove',
                    key
                });
            }
            // Set event
            simpleEventEmitter.notify({
                type: 'set',
                key,
                value: newValue
            });
        });
    }
    return simpleEventEmitter;
}

//# sourceMappingURL=createLocalStorageEventListener.js.map